<template>
  <div class="personal-detail">
    <p class="title">个人客户还车</p>
    <div class="steps-wrapper">
      <ReturnCarStep
        :fixedStepIndex="originStep"
        :currentStepIndex="currentStep"
        :steps="stepList"
      />
    </div>
    <div>
      <keep-alive>
        <component :is="currentComponent" :orderId="queries.orderId" />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import ReturnCarStep from '../components/returnCarStep'

import ReturnCarBeginDetail from '@/pages/cars/returnCar/detail/components/returnCarBegin/index.vue'
import CheckoutCarDetail from '@/pages/cars/returnCar/detail/components/checkoutCar/index.vue'
import CheckoutOrderDetail from '@/pages/cars/returnCar/detail/components/checkoutOrder'
import CheckoutExpenseDetail from '@/pages/cars/returnCar/detail/components/checkoutExpense'

import {
  getReturnCarOrderDetail,
} from '@/api/domain/returnLease'
import { getPersonalOrderDetail } from '@/api/domain/orders'
import {
  ORDER_STATES,
  ORDER_TYPES,
  PERSONAL_RETURN_CAR_STEPS,
  RETURN_CAR_ORDER_STATES,
} from '@/pages/cars/returnCar/config'

export default {
  provide() {
    return {
      orderType: ORDER_TYPES.personal.value,
      orderData: this.orderData,
      returnCarOrderData: this.returnCarOrderData,
    }
  },
  data() {
    return {
      originStep: -1,
      currentStep: -1,
      stepList: PERSONAL_RETURN_CAR_STEPS,
      orderData: {},
      returnCarOrderData: {},
      queries: JSON.parse(decodeURIComponent(this.$route.query.query || '{}')),
    }
  },
  computed: {
    currentComponent() {
      if (this.currentStep === 0) {
        return 'ReturnCarBeginDetail'
      } else if (this.currentStep === 1) {
        return 'CheckoutCarDetail'
      } else if (this.currentStep === 2) {
        return 'CheckoutOrderDetail'
      } else if (this.currentStep === 3) {
        return 'CheckoutExpenseDetail'
      }
      return ''
    },
  },
  methods: {
    async init() {
      const { id, orderId } = this.queries

      if (orderId) {
        await this.getOrderDetail(orderId)
      }

      if (id || orderId) {
        await this.getReturnCarOrderDetail({
          id,
          orderId,
        })
      }

      this.locateStepByOrderData()
    },
    locateStepByOrderData() {
      const { state } = this.orderData
      const { state: returnCarState } = this.returnCarOrderData
      let step = 0

      // 先看退车单状态是否“已关闭”和“已完成”，然后再看订单状态
      if (returnCarState === RETURN_CAR_ORDER_STATES.returnCarClosed.value) {
        step = 0
      } else if (
        returnCarState === RETURN_CAR_ORDER_STATES.returnCarCompleted.value
      ) {
        step = 4
      } else if (state === ORDER_STATES.returnCarCheckoutWaiting.value) {
        step = 0
      } else if (state === ORDER_STATES.checkoutOrderWaiting.value) {
        step = 1
      } else if (state === ORDER_STATES.checkoutExpenseWaiting.value) {
        step = 2
      }

      this.originStep = step
      this.currentStep = 0
    },
    async getOrderDetail(orderId) {
      if (orderId) {
        let res

        try {
          res = await getPersonalOrderDetail({
            orderId: parseInt(orderId),
          })
        } catch (err) {
          console.error(err)
        }

        if (!res) return

        const { code, data } = res
        if (code === 1) {
          Object.keys(data).forEach((key) => {
            this.orderData[key] = data[key]
          })
        }
      }
    },
    async getReturnCarOrderDetail({ id, orderId }) {
      let res

      try {
        res = await getReturnCarOrderDetail({
          id,
          orderId,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1) {
        Object.keys(data).forEach((key) => {
          this.returnCarOrderData[key] = data[key]
        })
      }
    },
  },
  created() {
    this.init()
  },
  components: {
    ReturnCarStep,
    ReturnCarBeginDetail,
    CheckoutCarDetail,
    CheckoutOrderDetail,
    CheckoutExpenseDetail,
  },
}
</script>

<style lang="scss" scoped>
.title {
  width: 100%;
  height: 40px;
  line-height: 40px;
  padding: 0 12px;
  font-weight: 600;
  font-size: 16px;
  color: #323233;
  margin-bottom: 14px;
}
.steps-wrapper {
  margin: 0 24px;
  padding: 24px 0 24px;
}
</style>
